export default function useResize(Table) {
    return Table;
}

useResize.displayName = 'useResize';
useResize.dependence = [];
useResize.hooks = function() {
    this.store.rowsHeight = {};
    this.store.columnsWidth = {};
    return {
        setColumnsWidth: widths => {
            this.store.columnsWidth = widths;
            
            this.updateColumnsWidth();
        },
        getColumnsWidth: () => {
            return this.store.columnsWidth;
        },
        updateColumnsWidth: ({ shouldUpdate = true } = {}) => {
            let lastOffset = 0;

            this.store.columnWidthOffsets = this.store.visibleLeafColumnKeys.reduce((offsets, colKey) => {
                offsets[colKey] = lastOffset;
                lastOffset += this.store.columnsWidth?.[colKey] ?? this.getColumnProps(colKey, 'width');
                return offsets;
            }, {});

            shouldUpdate && this.forceUpdate();
        },
        resetColumnsWidth: () => {
            this.store.columnsWidth = null;
        },
        setRowsHeight: heights => {
            this.store.rowsHeight = heights;
            this.updateRowsHeight();
        },
        getRowsHeight: () => {
            return this.store.rowsHeight;
        },
        updateRowsHeight: ({ shouldUpdate = true } = {}) => {
            let lastOffset = 0,
                rowHeight = this.getComponent('Table')?.current.props.rowHeight ?? 30;

            this.store.rowHeightOffsets = this.store.visibleRowKeys.reduce((offsets, rowKey) => {
                offsets[rowKey] = lastOffset;
                lastOffset += this.store.rowsHeight?.[rowKey] ?? rowHeight;
                return offsets;
            }, {});

            shouldUpdate && this.forceUpdate();
        },
        resetRowsHeight: () => {
            this.store.rowsHeight = null;
            this.forceUpdate();
        },
    };
};
useResize.propsGenerator = function(props) {
    return {
        ...props,
        columnsWidth: props.store.getColumnsWidth(),
        rowsHeight: props.store.getRowsHeight(),
        onColumnResize: widths => {
            props.store.setColumnsWidth(widths);
        },
        onRowResize: heights => {
            props.store.setRowsHeight(heights);
        },
    };
};